import React from 'react';
import '../_accordion.scss';

const Panel = ({children, active}) => (
    <div className={'accordion--panel' + (active?' active':'')}>
        {children}
    </div>
)

export default Panel


// WEBPACK FOOTER //
// ./src/components/accordion/panel/index.jsx